import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import VuePaginate from 'vue-paginate'
import VueMoment from 'vue-moment'
import VCalendar from 'v-calendar'
import 'v-calendar/lib/v-calendar.min.css'
import VueForceNextTick from 'vue-force-next-tick'
import { Events, Passport } from 'whitebox-presentation'

Vue.config.productionTip = false

library.add(fas)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('multiselect', Multiselect)

Vue.component('whitebox-events', Events)
Vue.component('whitebox-passport', Passport)

Vue.use(VueMoment)
Vue.use(VuePaginate)
Vue.use(VCalendar, { firstDayOfWeek: 2 })
Vue.use(VueForceNextTick)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')